import CityPagePersianas from "../components/CityPagePersianas";

export default function PersianasEstepona() {
  return (
    <CityPagePersianas
      name="Estepona"
      slug="estepona"
      cp="29680-29689"
      poblacion={79539}
      zonaGeo="Costa del Sol Occidental"
      lat={36.4276}
      lng={-5.1453}
      zonas={[
        "Centro Histórico",
        "Selwo",
        "Costa Galera",
        "Cancelada",
        "El Padrón",
        "Reinoso",
        "Atalaya",
      ]}
      landmarks={[
        "Plaza de las Flores",
        "Paseo Marítimo",
        "Puerto Deportivo",
        "Orquidario",
      ]}
      municipiosLimitrofes={[
        "Marbella",
        "Benahavís",
        "Casares",
        "Manilva",
      ]}
      festivalLocal="Feria y Fiestas Mayores, primera semana de julio"
      contextoTipologico="Pueblo blanco mejor cuidado de la Costa del Sol, calles peatonales floridas, urbanizaciones premium frente al mar, residentes expat europeos."
      isCoreZone={true}
    />
  );
}